import { isValid } from "date-fns/isValid";

export const getValidDate = (date?: Date | string) =>
  date ? (isValid(new Date(date)) ? new Date(date) : undefined) : undefined;
